<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/detailedhappyreturn/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      downloadPower="/detailedhappyreturn/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.memId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.phoneNumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merchantNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input
          v-model="formModel.merchantPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input v-model="formModel.batchNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column prop="chnCode" label="通道代码" :formatter="formatterTableData" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="memId" label="代理商ID" :formatter="formatterTableData" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="userName"
        label="代理商姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="phoneNumber" label="代理商手机号" :formatter="formatterTableData" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="sn"
        label="SN号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="merchantPhone" label="商户手机号" :formatter="formatterTableData" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="idCardNo" label="商户身份证号" :formatter="formatterTableData" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="batchNo"
        label="批次号"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operationAmt"
        label="金额(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="operationIntegral"
        label="积分"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="操作时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "detailedhappyreturn",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        memId: "",
        phoneNumber: "",
        merchantNo: "",
        merchantPhone: "",
        batchNo: "",
        time: TimeRange.monthRange,
      },
      tableData: [],
      submitService: TransactionService.detailedhappyreturnList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        memId: this.formModel.memId,
        phoneNumber: this.formModel.phoneNumber,
        merchantNo: this.formModel.merchantNo,
        merchantPhone: this.formModel.merchantPhone,
        batchNo: this.formModel.batchNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportHlfInfo",
            "8885",
            "/hlf/t-hlf-info-dtl/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/DetailedHappyReturn.vue